{
  "name": "MultiOne",
  "version": "v1.25_c75ec28e",
  "scripts": {
    "pretest": "node scripts/clean-test-cache.js",
    "pretest:headless": "node scripts/clean-test-cache.js",
    "pretest:watch": "node scripts/clean-test-cache.js",
    "ng": "ng",
    "start": "ng serve",
    "build": "node scripts/set-version.js && node scripts/generate-licenses.js && ng build --configuration production",
    "test": "ng test",
    "test:headless": "ng test --watch=false --browsers=ChromeHeadlessNoSandbox --code-coverage",
    "lint": "eslint src/**/*.ts",
    "lint:fix": "eslint src/**/*.ts --fix",
    "security:audit": "npm audit --audit-level moderate",
    "security:fix": "npm audit fix",
    "sonar": "sonar-scanner",
    "mend": "java -jar wss-unified-agent-20.10.1.jar -c wss-unified-agent.config"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.20",
    "@angular/common": "^21.2.19",
    "@angular/compiler": "^21.2.19",
    "@angular/core": "^21.2.19",
    "@angular/forms": "^21.2.20",
    "@angular/localize": "^21.2.20",
    "@angular/platform-browser": "^21.2.20",
    "@angular/platform-browser-dynamic": "^21.2.20",
    "@angular/router": "^21.2.20",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.8.2",
    "@ngx-formly/bootstrap": "^7.1.0",
    "@ngx-formly/core": "^7.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "angular-oauth2-oidc": "^21.0.2",
    "bootstrap": "^5.3.3",
    "d3": "^7.9.0",
    "d3-color": "^3.1.0",
    "file-saver": "^2.0.5",
    "jsrsasign": "^11.1.1",
    "jwt-decode": "^4.0.0",
    "loader-utils": "2.0.4",
    "ngx-pagination": "^6.0.3",
    "@angular-slider/ngx-slider": "^21.0.0",
    "tslib": "^2.7.0",
    "uuid": "^14.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.16",
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.16",
    "@angular/cli": "^21.2.16",
    "@angular/compiler-cli": "^21.2.20",
    "@angular/language-service": "^21.2.20",
    "@types/jasmine": "^5.1.4",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^20.19.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "eslint": "^9.0.0",
    "jasmine-core": "^5.1.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "rxjs": "~7.8.2",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3",
    "webpack": "^5.95.0",
    "webpack-dev-middleware": "^7.4.2"
  },
  "resolutions": {
    "jsrsasign": "^11.1.1",
    "minimist": "^1.2.8",
    "follow-redirects": "^1.15.6",
    "semver": "^7.6.3",
    "loader-utils": "^3.3.1",
    "nth-check": "^2.1.1",
    "decode-uri-component": "^0.2.2",
    "json5": "^2.2.3",
    "bootstrap": "^5.3.3",
    "browserslist": "^4.28.8"
  },
  "overrides": {
    "minimist": "^1.2.8",
    "follow-redirects": "^1.15.6",
    "semver": "^7.6.3",
    "glob-parent": "^6.0.2",
    "nth-check": "^2.1.1",
    "decode-uri-component": "^0.2.2",
    "json5": "^2.2.3",
    "postcss": "^8.4.47",
    "ws": "^8.18.0",
    "browserslist": "^4.28.8"
  }
}
